export default __webpack_public_path__ + "static/media/exhibitor.1876b3cb.png";